import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Block } from "./block.js";
import { Function } from "./function.js";
import { Token } from "./token.js";
const { delimited, option, either, map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-syntax/#component-value}
 *
 * @public
 */
export class Component {
    static of(value) {
        return new Component(Array.from(value));
    }
    _value;
    constructor(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
    *[Symbol.iterator]() {
        yield* this._value;
    }
    equals(value) {
        return (value instanceof Component &&
            value._value.length === this._value.length &&
            value._value.every((token, i) => token.equals(this._value[i])));
    }
    toJSON() {
        return this._value.map((token) => token.toJSON());
    }
    toString() {
        return this._value.join("");
    }
}
/**
 * @public
 */
(function (Component) {
    /**
     * {@link https://drafts.csswg.org/css-syntax/#consume-a-component-value}
     */
    Component.consume = (input) => 
    // eta expansion is necessary for `this` binding to resolve correctly
    either(map(Block.consume, (value) => Component.of(value)), map(Function.consume, (value) => Component.of(value)), (input) => input
        .first()
        .map((token) => Result.of([
        input.rest(),
        Component.of([token]),
    ]))
        .getOr(Err.of("Unexpected end of file")))(input);
    /**
     * {@link https://drafts.csswg.org/css-syntax/#parse-component-value}
     */
    Component.parse = delimited(option(Token.parseWhitespace), Component.consume);
})(Component || (Component = {}));
//# sourceMappingURL=component.js.map